module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.videoList.length) ? _c('div', {
    staticClass: "relatevideos-list"
  }, [_c('h2', [_vm._v("相关视频(" + _vm._s(_vm.videoList && _vm.videoList.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('ul', _vm._l((_vm.videoList), function(video, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "headpic",
      style: ('background-image: url(' + _vm.fixImgUrl(video.headPic) + ')'),
      on: {
        "click": function($event) {
          _vm.toVideoPage(video.videoId)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(video.title))])])
  }))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37efe5b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/relateVideos.vue
// module id = 609
// module chunks = 10